import { render, staticRenderFns } from "./ComboProdutos.vue?vue&type=template&id=5ce09cf6&scoped=true"
import script from "./ComboProdutos.vue?vue&type=script&lang=js"
export * from "./ComboProdutos.vue?vue&type=script&lang=js"
import style0 from "./ComboProdutos.vue?vue&type=style&index=0&id=5ce09cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce09cf6",
  null
  
)

export default component.exports